const TSV_ACCOUNT_STATUSES = {
    ENABLED: 'enabled',
    DISABLED: 'disabled',
    NOT_BOUND: 'not_bound',
};

export { TSV_ACCOUNT_STATUSES };
//# sourceMappingURL=tsvAccountStatuses.js.map
